<template>
	<div>
		<a-spin :spinning="loading">
			<div style="min-height: 800px;" class="bg-w flex ">
				<div class="technician-detail-left">
					<div class="technician-detail-left-header">
						<div class="flex alcenter">
							<img  :src="detail.face" class="technician-detail-face"/>
							<div class="ml15">
								<div class="flex alcenter ">
									<div class="ft16 ftw600 cl-main text-over4">{{detail.name}}</div>
									<div class="appointment-technician-item-tag-status-on text-over ml4" v-if="detail.status==1">{{detail.status_means}}</div>
									<div class="appointment-technician-item-tag-status-off text-over ml4" v-if="detail.status==-1">{{detail.status_means}}</div>
									<div class="appointment-technician-item-tag-year text-over ml4">{{detail.working_collar}}年经验</div>
								</div>
								
								<div class="mt15 flex alcenter">
									<i class="iconfont iconcall_gray mr5 ft12 cl-notice"/>
									<div class="cl-info ft12 ftw400 text-over4">{{detail.mobile}}</div>
								</div>
								
								<div class="mt15 flex alcenter">
									<i class="iconfont icongongpai mr5 ft12 cl-notice"/>
									<div class="cl-info ft12 ftw400 text-over4">{{detail.job_number}}</div>
								</div>

								<div class="mt16 flex alcenter">
									等级：
									<div class="ft12 ftw400 cl-info ml4 text-over" v-if="detail.level == 1">资深治疗师</div>
									<div class="ft12 ftw400 cl-info ml4 text-over" v-if="detail.level == 2">总监治疗师</div>
									<div class="ft12 ftw400 cl-info ml4 text-over" v-if="detail.level == 3">专家治疗师</div>
								</div>
							</div>
						</div>
						
						<div class="mt24">
							<div class="ft14 ftwblod cl-main">简介：</div>
							<div class="mt12 ft12 ftw400 cl-main" style="line-height: 1.5;">
								{{detail.brief_introduction}}
							</div>
						</div>
						
						<div class="mt24">
							<a-spin :spinning="changTagsLoading">
								<div class="ft14 ftwblod cl-main">技能标签：</div>
								<div class="mt12">
									<a-input placeholder="回车添加标签" v-model="form.tag"  @pressEnter="addTag"/>
								</div>
								<div class="mt12 flex wrap">
									<div class="technician-detail-tags-item" v-for="(item,index) in detail.tags">
										<div class="flex alcenter">
											<div class="ft12 ftw400 cl-black">{{item}}</div>
											<i class="iconfont iconclose12 ft10 cl-notice ml4 clickAct" @click="delTag(index)"/>
										</div>
									</div>
								</div>
							</a-spin>
						</div>
					</div>
					
					<div class="technician-detail-left-content">
						<div class="technician-detail-left-content-item">
							<div class="flex space alcenter">
								<div class="ft14 ftw400 cl-main">被约人次</div>
								<div class="ft20 ftw600 cl-theme">{{detail.engaged_num}}次</div>
							</div>
						</div>
						
						<div class="technician-detail-left-content-item mt20">
							<div class="flex space alcenter">
								<div class="ft14 ftw400 cl-main">服务项目</div>
								<div class="ft20 ftw600 cl-theme" v-if="detail.projects_count > 0">{{detail.projects_count}}门</div>
								<div class="ft20 ftw600 cl-theme" v-else>暂无</div>
							</div>
						</div>
					</div>
					
				</div>
			
				<div class="technician-detail-right">
					<a-layout>
						<a-layout-header class="layout-classes-header">
							<a-menu class="classes-menu" :defaultSelectedKeys="[selectCurrent]" @click="selectMenu" mode="horizontal">
								<a-menu-item key="order">预约订单</a-menu-item>
								<a-menu-item key="project">服务项目</a-menu-item>
							</a-menu>
						</a-layout-header>
						<a-layout-content class="layout-classes-content">
							<div v-if="selectCurrent == 'order'">
								<order-detail :technician_id="technician_id"></order-detail>
							</div>
							<div v-if="selectCurrent == 'project'">
								<project-detail :technician_id="technician_id"></project-detail>
							</div>
						</a-layout-content>
					</a-layout>
				</div>
			</div>
		</a-spin>
	</div>
</template>

<script>
	import orderDetail from './components/TechnicianDetail/order.vue';
	import projectDetail from './components/TechnicianDetail/project.vue';
	export default{
		components:{
			orderDetail,
			projectDetail
		},
		data(){
			return{
				loading:false,
				changTagsLoading:false,
				technician_id:0,
				selectCurrent: 'order',
				form:{
					tag:'',
				},
				detail:{
					face:'',
					name:'',
					mobile:'',
					working_collar:0,
					job_number:'',
					brief_introduction:'',
					status:1,
					status_means:'',
					engaged_num:0,
					projects_count:0,
					tags:[],
				}
			}
		},
		created() {
			if (!this.$route.query.id) {
				this.technician_id=0;
			} else {
				this.technician_id = parseInt(this.$route.query.id);
			}
			this.loaddata();
		},
		methods:{
			
			loaddata(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getTechnicianDetail',{
					technician_id:this.technician_id
				}).then(res=>{
					this.detail=res.detail;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
					this.$router.go(-1);
				})
			},
			
			
			selectMenu(e) {
				this.selectCurrent = e.key;
			},
			
			
			
			addTag(){
				if(this.form.tag == ''){
					this.$message.error('请填写标签在回车');
					return;
				}
				this.detail.tags.push(this.form.tag);
				this.form.tag='';
				this.changeTags(this.detail.tags);
			},
			
			delTag(index){
				if(this.detail.tags.length <= 1){
					this.$message.error('至少保留一个标签');
					return;
				}
				this.detail.tags.splice(index,1);
				this.changeTags(this.detail.tags);
			},
			
			changeTags(tags){
				if(this.changTagsLoading==true) return;
				this.changTagsLoading=true;
				this.$http.api('admin/changTagsFromTechnicianDetail',{
					technician_id:this.technician_id,
					tags:this.detail.tags,
				}).then(res=>{
					this.changTagsLoading=false;
				}).catch(res=>{
					console.log(res);
					this.changTagsLoading=false;
				})
			}
		}
	}
</script>

<style>
	.technician-detail-left{
		width: 400px;
		min-height: 800px;
		border-right: 1px solid #EBEDF5;
		line-height: 1;
	}
	.technician-detail-left-header{
		/* height: 128px; */
		padding: 24px;
		border-bottom: 1px solid #EBEDF5;
	}
	
	.technician-detail-left-header-action{
		width: 272px;
		height: 50px;
		background: #FFFFFF;
		border-radius: 8px;
		border: 1px solid #EBEDF5;
		padding: 0px 20px 0px 24px;
	}
	.technician-detail-face{
		width: 80px;
		height: 80px;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
	}
	
	.technician-detail-left-content{
		padding: 24px;
	}
	
	.technician-detail-left-content-item{
		width: 100%;
		height: 72px;
		background: #F7F8FC;
		border-radius: 8px;
		padding: 20px;
	}
	
	
	.technician-detail-right{
		width: 100%;
	}
	
	
	.appointment-technician-item-tag-status-on{
		border-radius: 2px;
		border: 1px solid #4772FF;
		padding: 2px 6px;
		font-size: 12px;
		font-weight: 400;
		color: #4772FF;
	}
	
	.appointment-technician-item-tag-status-off{
		border-radius: 2px;
		border: 1px solid #A6AEC2;
		padding: 2px 6px;
		font-size: 12px;
		font-weight: 400;
		color: #A6AEC2;
	}
	
	.appointment-technician-item-tag-year{
		background: rgba(242, 130, 40, 0.1);
		border-radius: 2px;
		border: 1px solid rgba(177, 117, 34, 0.5);
		padding: 2px 6px;
		font-size: 12px;
		font-weight: 400;
		color: #B17522;
	}
	
	.technician-detail-tags-item{
		padding: 7px 12px;
		background: #F5F6FA;
		border-radius: 15px;
		margin-right: 8px;
		margin-bottom: 8px;
		line-height: 1;
	}
	
	
	
	.layout-classes-header {
		background: #FFFFFF;
	}
	
	.layout-classes-header {
		padding: 0 20px;
		height: 58px;
		line-height: 57px;
		border-bottom: 1px solid #F0F3F5;
		width: 100%;
	}
	
	.layout-classes-content {
		padding: 0px 0px 10px 0px;
		background: #FFFFFF;
		width: 100%;
	}
	
	.classes-menu {
		border-bottom: none;
		line-height: 55px;
		font-size: 14px;
	}
</style>
